import styled, { css } from "styled-components";

export const Badge = styled.div`
  width: 100%;
  max-width: ${props => props.$width ? `${props.$width}px` : 'max-content'};
  height: auto;
  font-size: 12px;
  text-transform: capitalize;
  text-align: center;
  letter-spacing: 0.5px;
  padding: 4px 12px;
  border-radius: 3rem;
  display: inline-block;

  ${(props) =>
        props.type === 'default' &&
        css`
      background-color: var(--color-default);
      color: var(--theme-color-white);

      ${props.$outline &&
            css`
        background-color: transparent;
        color: var(--color-default);
        border: 1px solid var(--color-default);
      `}
    `}

  ${(props) =>
        props.type === 'success' &&
        css`
      background-color: var(--color-success);
      color: var(--theme-color-white);

      ${props.$outline &&
            css`
        background-color: transparent;
        color: var(--color-success);
        border: 1px solid var(--color-success);
      `}
    `}

  ${(props) =>
        props.type === 'warning' &&
        css`
      background-color: var(--color-warning);
      color: var(--theme-color-white);

      ${props.$outline &&
            css`
        background-color: transparent;
        color: var(--color-warning);
        border: 1px solid var(--color-warning);
      `}
    `}

  ${(props) =>
        props.type === 'error' &&
        css`
      background-color: var(--color-error);
      color: var(--theme-color-white);

      ${props.$outline &&
            css`
        background-color: transparent;
        color: var(--color-error);
        border: 1px solid var(--color-error);
      `}
    `}

  @media only screen and (max-width: 600px) {
    font-size: 10px;
  }
`;